import React, { useEffect, useState } from "react";
import { Box, Typography, Collapse, IconButton, Grid } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import url from '../Assets/Images/listIcon.png'
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";



const Services = ({ services,isNavigate = false  }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate()

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animation happens only once
    });
  }, []);


  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/&/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  };

  return (
    <Box className='w-100'>
      {services?.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <Box
            key={index}
            sx={{
              borderBottom: "1px solid #dcdcdc",
              py: { xs: 2, md: 3 },
            }}

          >
            {/* Title Row */}
            <Box
              padding={0}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >

              <Typography onClick={() => { if(isNavigate){ navigate(`/services/${item?.navigateurl}`)}}} data-aos="fade-up" sx={{ cursor: 'pointer !important' }} className="fs-36 fw-bold text-color-main"
              >
                {item.title}
              </Typography>

              <IconButton
                onClick={() => handleToggle(index)}
                sx={{
                  transform: !isOpen ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "0.3s ease",
                }}
              >
                <ArrowOutwardIcon className="text-color-main" />
              </IconButton>
            </Box>

            {/* Description */}
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <Typography className='fs-20 text-grey my-2'>{item?.description}</Typography>
              {item.overviewLine && <Typography class='fs-24 text-color-main fw-bold my-3'>{item.overviewLine}</Typography>}
              <Grid container className='mt-5'>
                {
                  item?.descriptions?.map((item) => (
                    <Grid className='d-flex' gap={'15px'} size={{ xs: 12, md: 6 }}>
                      <div class='list-icon'></div>
                      <Box flex={1}>
                        <Typography class='fs-24 text-color-main fw-bold mb-0'>{item.title}</Typography>
                        <Typography class='fs-20 text-grey'>{item.description}</Typography>
                      </Box>
                    </Grid>
                  ))
                }
              </Grid>
              <div
                data-aos="zoom-in"
                className="text-grey fs-20"
                dangerouslySetInnerHTML={{ __html: item.overview }}
              />
              <Grid container spacing={2}>
                {item?.images?.map((img, index) => (
                  <Grid onClick={() => { navigate(`/client-details/${img?.value}`) }} key={index} size={{ xs: 12, md: 4, xl: 4 }}>

                    <Box className="flip-card">
                      <Box className="flip-card-inner">

                        {/* FRONT */}
                        <Box className="flip-card-front">
                          <Box component="img" src={img.front} width="100%" />
                        </Box>

                        {/* BACK */}
                        <Box className="flip-card-back">
                          <Box component="img" src={img.back} width="100%" />
                        </Box>

                      </Box>
                    </Box>

                  </Grid>
                ))}
              </Grid>
            </Collapse>
          </Box>
        );
      })}
    </Box>
  );
};

export default Services;
